import * as React from "react";
import { Button, makeStyles, Spinner, Text, tokens } from "@fluentui/react-components";
import { LockClosedRegular } from "@fluentui/react-icons";
import { useAuth } from "../contexts/AuthContext";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    minHeight: "400px",
    textAlign: "center",
  },
  logo: {
    fontSize: "64px",
    marginBottom: "20px",
    color: tokens.colorBrandBackground,
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "10px",
    color: tokens.colorNeutralForeground1,
  },
  subtitle: {
    fontSize: "14px",
    color: tokens.colorNeutralForeground3,
    marginBottom: "30px",
    maxWidth: "320px",
  },
  loginButton: {
    minWidth: "200px",
    marginBottom: "20px",
  },
  errorMessage: {
    marginTop: "20px",
    maxWidth: "320px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
});

export const Login: React.FC = () => {
  const styles = useStyles();
  const { login, isLoading } = useAuth();
  const handleLogin = async () => {
    try {
      await login();
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  return (
    <div className={styles.container}>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Spinner size="large" label="Authenticating with Keycloak..." />
          <Text>Please wait while we log you in...</Text>
        </div>
      ) : (
        <>
          <div className={styles.logo}>
            <LockClosedRegular />
          </div>

          <Text className={styles.title}>Welcome to KARLI</Text>

          <Button
            appearance="primary"
            size="large"
            className={styles.loginButton}
            onClick={handleLogin}
            disabled={isLoading}
          >
            Login to KARLI
          </Button>
        </>
      )}
    </div>
  );
};

export default Login;
